import { createApp } from 'vue';

import ListingsContainer from '../components/listings/listings-container.vue';
import getWindowSize from '../helpers/getWindowSize';

const listingsElement = document.getElementById('listings-container');

if (listingsElement) {
	const listingsApp = createApp({
		components: { ListingsContainer },
		template: '<ListingsContainer :window-size="windowSize" />',
		data() {
			return { windowSize: getWindowSize() };
		},
		mounted() {
			window.addEventListener('resize', this.updateWindowSize);
		},
		beforeUnmount() {
			window.removeEventListener('resize', this.updateWindowSize);
		},
		methods: {
			updateWindowSize() {
				this.windowSize = getWindowSize();
			},
		},
	});

	listingsApp.config.compilerOptions.whitespace = 'preserve';
	listingsApp.mount(listingsElement);
}
